import { setCookie } from 'shared/custom/utils/cookieHandler';

/**
 * Generates an event ID following the required structure:
 * "randomNumber + unixTimestamp"
 */
const generateEventId = () => {
	const random = Math.floor(Math.random() * 1_000_000_000); // random number
	const timestamp = Math.floor(Date.now() / 1000); // unix timestamp (seconds)
	return `${random}${timestamp}`;
};

/**
 * Sets the required cookies for CAPI:
 * "_mfbt" → pageview event
 * "mfbt"  → other events
 *
 * Both must exist per session
 */
export const setCookieCAPI = (cookieName: '_mfbt' | 'mfbt') => {
	const eventId = generateEventId();

	setCookie(cookieName, eventId, 1);

	return eventId;
};
